module.exports = __webpack_public_path__ + "img/16_BC17_erect_a_shrine.36e56da0.jpg";